import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const SecuritySolid = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M7.8225 1.35611C7.73542 1.27356 7.62 1.22754 7.5 1.22754C7.38001 1.22754 7.26459 1.27356 7.17751 1.35611C5.8508 2.61604 4.08383 3.30694 2.25438 3.28111C2.15471 3.27982 2.05723 3.31032 1.97608 3.36821C1.89494 3.42609 1.83435 3.50833 1.80313 3.60299C1.53936 4.40684 1.40539 5.24759 1.40625 6.09361C1.40625 9.80736 3.94625 12.9267 7.38313 13.8111C7.45979 13.8309 7.54022 13.8309 7.61688 13.8111C11.0538 12.9267 13.5938 9.80736 13.5938 6.09361C13.5938 5.22486 13.4544 4.38736 13.1969 3.60299C13.1658 3.50821 13.1052 3.42583 13.0241 3.36783C12.9429 3.30983 12.8454 3.27923 12.7456 3.28049L12.6563 3.28111C10.7838 3.28111 9.08313 2.54986 7.8225 1.35611ZM9.75626 6.36611C9.79375 6.31614 9.82089 6.25918 9.83606 6.19858C9.85123 6.13798 9.85414 6.07495 9.8446 6.01321C9.83507 5.95147 9.81328 5.89225 9.78054 5.83905C9.74779 5.78584 9.70474 5.73972 9.65392 5.70339C9.60309 5.66707 9.54551 5.64126 9.48457 5.62751C9.42363 5.61375 9.36056 5.61231 9.29905 5.62328C9.23755 5.63424 9.17886 5.65739 9.12643 5.69137C9.074 5.72534 9.02889 5.76946 8.99376 5.82111L6.97125 8.65236L5.95625 7.63736C5.86739 7.55456 5.74987 7.50948 5.62843 7.51163C5.50699 7.51377 5.39112 7.56297 5.30524 7.64885C5.21936 7.73473 5.17016 7.8506 5.16802 7.97204C5.16588 8.09347 5.21095 8.211 5.29375 8.29986L6.70001 9.70611C6.74812 9.75419 6.80613 9.79123 6.87 9.81464C6.93387 9.83805 7.00206 9.84729 7.06986 9.8417C7.13765 9.83611 7.20342 9.81583 7.26259 9.78227C7.32175 9.74871 7.37291 9.70268 7.4125 9.64736L9.75626 6.36611Z" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="solid" viewBox="-0.5 -0.5 16 16">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { SecuritySolid };